import React from 'react';
import { Feature } from '@loyalty/shared-common';
import { RuleAttributes, RuleType } from '@loyalty/shared-common/rule-api-client';
import {
  EarningRuleFormValue,
  earningRuleAttributesToFormValue,
  earningRuleForm,
  formValueToEarningRuleInput,
} from './form';
import { EarningRulePanels } from './EarningRulePanels';
import { RuleModal } from '../rules/components/RuleModal';
import { useCurrencies } from '../currency/CurrenciesContext';
import { useFeatures } from '../features/FeaturesContext';
import { useProgram } from '../loyalty/ProgramContext';

export interface EarningRuleModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  rule?: RuleAttributes;
}

export function EarningRuleModal({ isOpen, setIsOpen, rule }: EarningRuleModalProps) {
  const { features } = useFeatures();
  const { currencies } = useCurrencies();
  const { program } = useProgram();

  const { write: canEdit } = features[Feature.EARNING_RULE];

  return (
    <RuleModal<EarningRuleFormValue>
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      rule={rule}
      formValueToRuleInput={formValueToEarningRuleInput}
      formSchema={earningRuleForm}
      getResetValue={() =>
        earningRuleAttributesToFormValue(rule, currencies, program.languages, program.timezone)
      }
      canEdit={canEdit}
      ruleType={RuleType.EARN}
    >
      <EarningRulePanels />
    </RuleModal>
  );
}
